import { render } from "./LetterImgUpload.vue?vue&type=template&id=32099ce2&scoped=true"
import script from "./LetterImgUpload.vue?vue&type=script&lang=js"
export * from "./LetterImgUpload.vue?vue&type=script&lang=js"

import "./LetterImgUpload.vue?vue&type=style&index=0&id=32099ce2&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32099ce2"]])

export default __exports__